import validator from 'validatorjs';

const validate = (installment: number) => {
  return installment !== 0;
};

validator.register('installments', validate, 'invalid_installment');


// WEBPACK FOOTER //
// ./src/validators/installments.ts